import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=70d3989b&scoped=true"
import script from "./Notice.vue?vue&type=script&setup=true&lang=js"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=70d3989b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3989b",
  null
  
)

export default component.exports